<section class="client-view-page">
  <a class="back-link" routerLink="/dashboard/clients">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
    <span>К списку клиентов</span>
  </a>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="view-loading" *ngIf="loading">Загрузка клиента...</div>

  <ng-container *ngIf="client && !loading">
    <div class="view-grid">
      <aside class="left-column">
        <section class="profile-card">
          <div class="avatar" [class.inactive]="client.status === 'inactive'">{{ initials }}</div>
          <h1>{{ clientName }}</h1>
          <span *ngIf="client.email">{{ client.email }}</span>
          <strong class="status-pill" [class.active]="client.status === 'active'">
            {{ client.status === 'active' ? 'Активен' : 'Не активен' }}
          </strong>
          <div class="profile-badges">
            <span [ngClass]="warmthBadgeClass">{{ warmthBadge }}</span>
            <span [ngClass]="loyaltyBadgeClass">{{ loyaltyBadge }}</span>
            <span class="reserved" *ngIf="hasReservedOrders">Есть резерв</span>
          </div>

          <span class="profile-divider" aria-hidden="true"></span>

          <a class="primary-link" [routerLink]="['/dashboard/clients', client.publicIdentifier || client.id, 'edit']">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
            <span>Редактировать</span>
          </a>

          <button class="danger-link" type="button" (click)="deleteClient()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
            <span>Удалить клиента</span>
          </button>
        </section>

        <section class="info-card">
          <h2>Основные данные</h2>
          <dl>
            <div><dt>Телефон</dt><dd>{{ formatPhone(client.phone) }}</dd></div>
            <div><dt>Скидка</dt><dd>{{ formatDiscount(client.personalDiscountPercent) }}</dd></div>
          </dl>
        </section>

        <section class="info-card">
          <h2>Связь</h2>
          <dl>
            <div><dt>Источник</dt><dd>{{ client.acquisitionSource?.name || 'Не указан' }}</dd></div>
            <div *ngIf="client.telegramId"><dt>Telegram ID</dt><dd>{{ formatGroupedNumber(client.telegramId) }}</dd></div>
            <div *ngIf="client.telegramUsername"><dt>Telegram username</dt><dd>{{ client.telegramUsername }}</dd></div>
            <div *ngIf="client.maxId"><dt>MAX ID</dt><dd>{{ formatGroupedNumber(client.maxId) }}</dd></div>
            <div *ngIf="client.avitoProfileUrl">
              <dt>Авито</dt>
              <dd><a class="external-link" [href]="client.avitoProfileUrl" target="_blank" rel="noreferrer" aria-label="Открыть Авито">↗</a></dd>
            </div>
          </dl>
        </section>

        <section class="info-card">
          <h2>Статус и настройки</h2>
          <dl>
            <div><dt>Подписка</dt><dd>{{ subscriptionText }}</dd></div>
            <div><dt>Ответственный</dt><dd>{{ client.owner?.displayName || client.owner?.username || 'Не назначен' }}</dd></div>
            <div><dt>Регистрация</dt><dd>{{ formatDate(client.createdAt) }}</dd></div>
            <div><dt>Изменен</dt><dd>{{ formatDate(client.updatedAt) }}</dd></div>
          </dl>
        </section>
      </aside>

      <main class="right-column">
        <section class="stats-grid">
          <article class="stat-card">
            <span>Заказы</span>
            <strong>{{ orders.length }}</strong>
            <small>{{ paidOrders.length }} оплачено</small>
            <i class="stat-icon orders"></i>
          </article>
          <article class="stat-card">
            <span>Средний заказ</span>
            <strong>{{ formatMoney(averagePaidOrderTotal) }}</strong>
            <small>{{ paidOrders.length }} покупок</small>
            <span class="stat-bars" aria-hidden="true">
              <i *ngFor="let bar of paidOrderSparkBars" [style.height.%]="bar"></i>
            </span>
          </article>
          <article class="stat-card">
            <span>Билеты</span>
            <strong>{{ paidTicketsTotal }}</strong>
            <small>в оплаченных заказах</small>
            <i class="stat-icon tickets"></i>
          </article>
          <article class="stat-card">
            <span>Сумма заказов</span>
            <strong>{{ formatMoney(paidOrdersTotal) }}</strong>
            <small>{{ paidOrders.length }} оплаченных</small>
            <span class="stat-bars alt" aria-hidden="true">
              <i *ngFor="let bar of paidOrderSparkBars" [style.height.%]="bar"></i>
            </span>
          </article>
        </section>

        <section class="info-card">
          <div class="card-heading">
            <h2>История заказов</h2>
            <span *ngIf="orders.length > 0">{{ orders.length }} заказов</span>
          </div>

          <div class="orders-loading" *ngIf="loadingOrders">Загрузка заказов...</div>

          <div class="orders-table-wrap" *ngIf="!loadingOrders && orders.length > 0; else emptyOrders">
            <table class="orders-table">
              <thead>
                <tr>
                  <th>Заказ</th>
                  <th>Событие</th>
                  <th>Билеты</th>
                  <th>Сумма</th>
                  <th>Статус</th>
                </tr>
              </thead>
              <tbody>
                <tr class="order-history-row" *ngFor="let order of orders; trackBy: trackById" [routerLink]="['/dashboard/orders', order.code || order.id]">
                  <td>
                    <strong>{{ order.code }}</strong>
                    <small>{{ formatDate(order.createdAt) }}</small>
                  </td>
                  <td>
                    <strong>{{ order.event?.name || 'Событие удалено' }}</strong>
                    <small>{{ order.event?.startsAt ? formatDate(order.event.startsAt) : 'Дата не указана' }}</small>
                  </td>
                  <td><span class="ticket-codes">{{ getOrderTicketsText(order) }}</span></td>
                  <td><strong>{{ formatMoney(order.total) }}</strong></td>
                  <td>
                    <span class="order-status" [ngClass]="getOrderStatusClass(order.status)">{{ getOrderStatusName(order.status) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #emptyOrders>
            <div class="orders-empty" *ngIf="!loadingOrders">
            <strong>Заказов пока нет</strong>
            </div>
          </ng-template>
        </section>

        <section class="info-card">
          <div class="card-heading">
            <h2>Заметки</h2>
          </div>

          <form class="note-form" (ngSubmit)="addNote()">
            <textarea class="note-input" name="newNoteText" rows="3" placeholder="Добавить новую заметку" [(ngModel)]="newNoteText"></textarea>
            <button class="primary-link" type="submit" [disabled]="savingNote || !newNoteText.trim()">{{ savingNote ? 'Сохраняем...' : 'Добавить заметку' }}</button>
          </form>

          <div class="notes-list" *ngIf="client.notes.length > 0; else emptyNotes">
            <article class="note-item" *ngFor="let note of client.notes; trackBy: trackById" [class.editing]="editingNoteId === note.id">
              <div class="note-content">
                <strong>{{ note.createdByUsername }}</strong>
                <textarea class="note-input note-edit-input" rows="3" *ngIf="editingNoteId === note.id" [(ngModel)]="editingNoteText"></textarea>
                <p *ngIf="editingNoteId !== note.id">{{ note.text }}</p>
              </div>

              <aside class="note-side">
                <div class="note-dates">
                  <time>{{ formatDate(note.createdAt) }}</time>
                  <span *ngIf="note.updatedAt !== note.createdAt">Изменена {{ formatDate(note.updatedAt) }}</span>
                </div>

                <div class="note-icon-actions">
                  <button class="icon-button edit" type="button" *ngIf="editingNoteId !== note.id" (click)="startEditNote(note.id, note.text)" aria-label="Редактировать заметку" title="Редактировать">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                  </button>
                  <button class="icon-button delete" type="button" *ngIf="editingNoteId !== note.id" (click)="deleteNote(note.id)" aria-label="Удалить заметку" title="Удалить">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
                  </button>
                  <button class="icon-button save" type="button" *ngIf="editingNoteId === note.id" (click)="saveNote(note.id)" aria-label="Сохранить заметку" title="Сохранить">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><path d="M17 21v-8H7v8"/><path d="M7 3v5h8"/></svg>
                  </button>
                  <button class="icon-button cancel" type="button" *ngIf="editingNoteId === note.id" (click)="cancelEditNote()" aria-label="Отменить редактирование" title="Отмена">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                  </button>
                </div>
              </aside>
            </article>
          </div>
          <ng-template #emptyNotes>
            <p class="muted">Заметок пока нет.</p>
          </ng-template>
        </section>
      </main>
    </div>
  </ng-container>
</section>
